import { create } from 'zustand'

const useEditStore = create((set, get) => ({
  canUndo: false,
  canRedo: false,
  isPainting: false,
  imagePreviewRef: null,
  brushStrokes: [],
  currentStrokeIndex: -1,
  isBrushing: false,

  setImagePreviewRef: (ref) => set({ imagePreviewRef: ref }),
  
  handleStroke: (stroke) => {
    set(state => {
      const newStrokes = [...state.brushStrokes.slice(0, state.currentStrokeIndex + 1), stroke]
      return {
        brushStrokes: newStrokes,
        currentStrokeIndex: state.currentStrokeIndex + 1,
        isPainting: true,
        canUndo: true,
        canRedo: false
      }
    })
  },

  undo: () => {
    const state = get()
    if (state.currentStrokeIndex >= 0) {
      set(state => ({
        currentStrokeIndex: state.currentStrokeIndex - 1,
        canUndo: state.currentStrokeIndex - 1 >= 0,
        canRedo: true
      }))
      state.imagePreviewRef?.current?.undoStroke()
    }
  },

  redo: () => {
    const state = get()
    if (state.currentStrokeIndex < state.brushStrokes.length - 1) {
      set(state => ({
        currentStrokeIndex: state.currentStrokeIndex + 1,
        canUndo: true,
        canRedo: state.currentStrokeIndex + 2 < state.brushStrokes.length
      }))
      state.imagePreviewRef?.current?.redoStroke()
    }
  },

  completePainting: () => set({ isPainting: false }),
  
  reset: () => set({
    brushStrokes: [],
    currentStrokeIndex: -1,
    canUndo: false,
    canRedo: false,
    isPainting: false
  }),

  setIsBrushing: (value) => set({ isBrushing: value })
}))

export default useEditStore 